// Recently-opened server plans, remembered in localStorage so the ☰ menu can list them.
// Only touches localStorage inside functions (never at import) so the node-env unit tests
// can import the pure helpers.

export interface RecentPlan { guid: string; name: string; ts: number }

const KEY = "mpp:recents";
const CAP = 25;

// pure: dedup by guid, move the (re)opened plan to the front, newest first, capped
export function upsertRecent(list: RecentPlan[], guid: string, name: string, ts: number, cap = CAP): RecentPlan[] {
  const rest = list.filter((p) => p.guid !== guid);
  return [{ guid, name, ts }, ...rest].slice(0, cap);
}
export function removeFromList(list: RecentPlan[], guid: string): RecentPlan[] {
  return list.filter((p) => p.guid !== guid);
}

// localStorage wrappers — tolerant of a disabled/full/blocked store (never throw to callers)
function read(): RecentPlan[] {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(arr)) return [];
    return arr.filter((p) => p && typeof p.guid === "string" && p.guid);
  } catch { return []; }
}
function write(list: RecentPlan[]): void {
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* ignore quota / disabled */ }
}

export function listRecents(): RecentPlan[] { return read(); }
export function recordPlan(guid: string, name: string): void {
  if (!guid) return;
  write(upsertRecent(read(), guid, name || "Untitled plan", Date.now()));
}
export function removeRecent(guid: string): void { write(removeFromList(read(), guid)); }
